import axios from "axios";
import { getRequestedCountForBulk } from "./bulkPlacementBidUpdate";

export { getRequestedCountForBulk };

export const TARGETING_BULK_FIELD = {
  BID: "BID",
  STATUS: "STATUS",
};

/** Map UI / internal status to API adjustmentType. */
export function mapTargetingStatusAdjustmentType(status) {
  const normalized = String(status || "").toUpperCase();
  if (normalized === "PAUSED" || normalized === "PAUSE") return "PAUSE";
  if (normalized === "ENABLED" || normalized === "ENABLE") return "ENABLE";
  return normalized;
}

/**
 * Build targeting bulk body.
 * Bid:  { field: "BID", adjustmentType, value? } — omit value for COPY_CPC
 * Status: { field: "STATUS", adjustmentType: "PAUSE" | "ENABLE" }
 */
export function buildBulkTargetingUpdateBody({
  query,
  email,
  requestedCount,
  status,
  adjustmentType,
  value,
}) {
  let operation;

  if (status) {
    operation = {
      field: TARGETING_BULK_FIELD.STATUS,
      adjustmentType: mapTargetingStatusAdjustmentType(status),
    };
  } else {
    operation = {
      field: TARGETING_BULK_FIELD.BID,
      adjustmentType,
    };
    if (adjustmentType !== "COPY_CPC" && value !== null && value !== undefined) {
      operation.value = Number(value);
    }
  }

  return {
    filters: {
      query: { ...(query || {}) },
    },
    operation,
    email: email || "",
    requestedCount: Number(requestedCount) || 0,
  };
}

/**
 * POST /client/{clientId}:update-amazon-bulk-target
 */
export async function submitBulkTargetingUpdate({
  clientId,
  userPlatform = "amazon",
  skipEvents = true,
  body,
  token,
}) {
  const baseUrl = process.env.REACT_APP_ADS_API;
  const url = `${baseUrl}/client/${clientId}:update-amazon-bulk-target?skipEvents=${
    skipEvents ? "true" : "false"
  }&source=${userPlatform}`;

  const headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers.Authorization = token;
  }

  const response = await axios.post(url, body, { headers });
  return response?.data;
}
